import { StateMachineEventEnum } from '../model/stateMachineEvent';
import { GateAction } from '../model/live-flight';

export let BusEnum = {
  Air: "BKSAIR",
  Land: "BKSLAND",
  Transfer: "BKSTRF",
  Assign: 'BKS_ASSI',
  Start: 'BKS_START',
  Load: 'BKS_LOAD',
  Drive: 'BKS_DRV',
  Unload: 'BKS_UNL',
  Create: "BKS_CRT",
  Final: "BKS_FIN",
  Admin: "BKSADM",
  Misc: "BKSMISC",
  NoShow: "NoShow"
}

export let TransferStatus = {
  Unknown: "Unknown",
  Open: "Open",
  Pause: "Pause",
  Close: "Close"
}

export let GroupType = {
  Air: "Air",
  Land: "Land",
  Standby: "Standby",
  Coordinator: "Coordinator",
  Transfer: "Transfer",
  Flights: "Flights",
  Other: "Other"
}

export let EditModeEnum = {
  Create: "create",
  Edit: "edit",
  Misc: "misc",
  Copy: "copy",
  Add: "add"
}

export let ColorsEnum = {
  Planned: "pink",
  Assigned: "#808080",
  Accepted: "#373737",
  Started: "#0000FF",
  ArrivedEmpty: "#9696FF",
  Loading: "#6464FF",
  Driving: "#00FFFF",
  ArrivedFull: "#FFC800",
  Unloading: "#0FB496",
  Finished: "#14FF00",
  Final: "green",
  Cancelled: "#000000",
  Late: "#FDCCCE",
  NoShow: "Red",
  CancelledByApi: "#FF38DD",
  UnplannedFlightBackground: "#F0F0F0",
  UnplannedFlightHeader: "#999999",
  UnplannedFlightWarningHeader: "#F5B33C",
  UnplannedFlightErrorHeader: "#FC0D1B",
  PlannedHeaderNormal: "#1F9624",
  PlannedHeaderWarning: "#FB8033",
  PlannedHeaderMissingData: "#000000",
  Break: "#ffcccc",
  Working: "#e5faff",
  NonWorking: "#ffffff",
  Arrival: "#fbf9cc",
  Departure: "#dde9f6",
  DepartureRemoteTerminal: "white",
  Unknown: "#FFFFFF",
  Activity: "#F0F0F0",
  ActivityTextColor: "black",
  ActivityChangedTextColor: "red"
}

export let AdminEnum = {
  Break: "Rast",
  Misc: "Övrigt",
  Wash: "Tvätt",
  Fuel: "Tanka",
  Clean: "Städa",
  Coffe: "Kaffe",
  Meeting: "Möte",
  Standby: "Standby",
  StandbyDE: "Standby D/E",
  StandbyPalace: "Standby Palatset",
  Flight: "Flight",
  BusBooking: "Bussbokning",
  TransferPortalFrom: "Transport från Gate område A",
  TransferPortalTo: "Transport till Gate område A"
}

export let miscTypes = [AdminEnum.Break,
AdminEnum.Wash,
AdminEnum.Fuel,
AdminEnum.Clean,
AdminEnum.Coffe,
AdminEnum.Standby,
AdminEnum.Meeting,
AdminEnum.StandbyDE,
AdminEnum.StandbyPalace,
AdminEnum.Flight];

export let EventTypes: any[] = [
  { id: BusEnum.Admin, name: AdminEnum.Break, isSvgIcon: false, icon: "local_hotel", textLength: 14, displayText: AdminEnum.Break, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Coffe, isSvgIcon: false, icon: "local_cafe", textLength: 15, displayText: AdminEnum.Coffe, defaultTime: 0, available: false, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Wash, isSvgIcon: false, icon: "local_car_wash", textLength: 15, displayText: AdminEnum.Wash, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Fuel, isSvgIcon: false, icon: "local_gas_station", textLength: 16, displayText: AdminEnum.Fuel, defaultTime: 15, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Clean, isSvgIcon: false, icon: "delete", textLength: 15, displayText: AdminEnum.Clean, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.BusBooking, isSvgIcon: false, icon: "directions_bus", textLength: 19, displayText: AdminEnum.BusBooking, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Admin, name: AdminEnum.Meeting, isSvgIcon: false, icon: "people", textLength: 15, displayText: AdminEnum.Meeting, defaultTime: 60, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Standby, isSvgIcon: false, icon: "filter_5", textLength: 19, displayText: AdminEnum.Standby, defaultTime: 0, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.StandbyDE, isSvgIcon: false, icon: "filter_2", textLength: 19, displayText: AdminEnum.Standby, defaultTime: 0, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.StandbyPalace, isSvgIcon: false, icon: "house", textLength: 19, displayText: AdminEnum.Standby, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Flight, isSvgIcon: false, icon: "flight", textLength: 19, displayText: AdminEnum.Flight, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.TransferPortalFrom, isSvgIcon: true, icon: "from-gate-a", textLength: 19, displayText: AdminEnum.TransferPortalFrom, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.TransferPortalTo, isSvgIcon: true, icon: "to-gate-a", textLength: 19, displayText: AdminEnum.TransferPortalTo, defaultTime: 30, available: true, state: StateMachineEventEnum.Planned },
  { id: BusEnum.Misc, name: AdminEnum.Misc, isSvgIcon: false, icon: "create", textLength: 0, displayText: "", defaultTime: 30, available: true, state: StateMachineEventEnum.Planned }
];


export let activityAbbreviations: any[] = [
  { state: StateMachineEventEnum.Create, text: "CRT", color: ColorsEnum.Assigned, translated: "Skapad", legend: false, eta: true },
  { state: StateMachineEventEnum.Planned, text: "PLA", color: ColorsEnum.Planned, translated: "Planerad", legend: true, eta: true },
  { state: StateMachineEventEnum.Assign, text: "TIL", color: ColorsEnum.Assigned, translated: "Tilldela", legend: true, eta: true },
  { state: "UnAssign", text: "", color: ColorsEnum.Assigned, translated: "Avboka", legend: false, eta: true },
  { state: "ReAssign", text: "", color: ColorsEnum.Assigned, translated: "Tilldela annan", legend: false, eta: true },
  { state: StateMachineEventEnum.Accept, text: "ACC", color: ColorsEnum.Accepted, translated: "Acceptera", legend: true, eta: true },
  { state: StateMachineEventEnum.Start, text: "STA", color: ColorsEnum.Started, translated: "Starta", legend: true, eta: true },
  { state: StateMachineEventEnum.ArriveEmpty, text: "UPH", color: ColorsEnum.ArrivedEmpty, translated: "På upphämtningsplats", legend: true, eta: false },
  { state: StateMachineEventEnum.Loading, text: "LAS", color: ColorsEnum.Loading, translated: "Lastar", legend: true, eta: false },
  { state: StateMachineEventEnum.Driving, text: "KÖR", color: ColorsEnum.Driving, translated: "Kör", legend: true, eta: false },
  { state: StateMachineEventEnum.ArriveFull, text: "DST", color: ColorsEnum.ArrivedFull, translated: "Vid destination", legend: true, eta: false },
  { state: StateMachineEventEnum.Unloading, text: "LOS", color: ColorsEnum.Unloading, translated: "Lossar", legend: true, eta: false },
  { state: StateMachineEventEnum.Finish, text: "KLR", color: ColorsEnum.Finished, translated: "Klar", legend: true, eta: false },
  { state: StateMachineEventEnum.Final, text: "SLF", color: ColorsEnum.Final, translated: "Slutförd", legend: false, eta: false },
  { state: StateMachineEventEnum.Cancel, text: "AVB", color: ColorsEnum.Cancelled, translated: "Avbryt", legend: false, eta: false },
  { state: StateMachineEventEnum.NoShow, text: "BOM", color: ColorsEnum.NoShow, translated: "Bomkörning", legend: false, eta: false },
];

export function arrivalStatus(status: string): string {
  switch (status) {
    case "SCH":
      {
        return "B";
      }
    case "LAN":
      {
        return "L";
      }
    default:
      {
        return "?";
      }
  }
}

export function departureStatus(status: GateAction): any {
  if (status) {
    return status;
  }
  else {
    return "?";
  }
}

export const HeromaStates =
{
  unknown: 'heroma_unknown',
  error: 'heroma_error',
  warning: 'heroma_warning',
  ok: 'heroma_ok'
}

export const ImportLogType =
{
  Unknown: "Unknown",
  Entra: "Entra",
  AlreadyImported: "AlreadyImported",
  ManualImport: "ManualImport",
  LastImport: "LastImport"
}

export const ServiceTypes =
{
  repair: "Service",
  wash: "Tvätt"
}

export const Roles =
{
  Planner: "sys_planners",
  Dispatcher: "sys_dispatcher"
}
